export const roofKinds = {
  pent: 'pent',
  saddle: 'saddle',
  hip: 'hip',
  tent: 'tent',
}
